export default __webpack_public_path__ + "static/media/offer-2.15815323.jpg";